import { listAppsQueryOptions } from "@package/api-client/hooks/appsController";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/org/$orgId/app/$appId")({
	loader: async ({ context, params }) => {
		const apps = await context.queryClient.ensureQueryData(listAppsQueryOptions(params.orgId));
		const app = apps?.find((a) => a.id === params.appId);
		if (!app) {
			throw redirect({
				to: "/app/org/$orgId",
				params: { orgId: params.orgId },
			});
		}
		return { app };
	},
	component: AppLayout,
});

function AppLayout() {
	return <Outlet />;
}
